import React                    from 'react';
import { arrayXqty as tooltip } from 'pu-data/Tooltips';
import TextComponent            from './TextComponent';

const ArrayXQty = (props) => {
  const name = 'array_x_qty';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label="# of up in X"
      name={name}
      value={parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayXQty.defaultProps = {};

export default ArrayXQty;
